import { forwardRef } from 'react';
import type { ButtonHTMLAttributes, ReactNode } from 'react';
import styles from './Button.module.css';

type Variant = 'primary' | 'secondary' | 'ghost' | 'destructive';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  fullWidth?: boolean;
  compact?: boolean;
  leftSlot?: ReactNode;
  rightSlot?: ReactNode;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  {
    children,
    variant = 'primary',
    fullWidth,
    compact,
    leftSlot,
    rightSlot,
    className,
    type,
    ...rest
  },
  ref,
) {
  const classes = [
    styles.button,
    variant === 'secondary' && styles.secondary,
    variant === 'ghost' && styles.ghost,
    variant === 'destructive' && styles.destructive,
    fullWidth && styles.fullWidth,
    compact && styles.compact,
    className,
  ]
    .filter(Boolean)
    .join(' ');
  return (
    <button ref={ref} type={type ?? 'button'} className={classes} {...rest}>
      {leftSlot}
      {children}
      {rightSlot}
    </button>
  );
});
